import React from "react";
import PropTypes from "prop-types";
import Contacts from "./Contacts";

class ContactSearcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      contacts: [],
    };
  }

  onKeyPress = (event) => {
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
    }
  };

  // Only perform search when
  // - the number of enetered characters is > 3
  // - It has been 300ms since the last keypress
  handlSearchChange = (event) => {
    var search = event.target.value;
    this.setState({ search });
    if (this.fetching) {
      clearTimeout(this.fetching);
    }
    if (search.length < 4) {
      this.setState({
        contacts: [],
      });
    } else {
      this.fetching = setTimeout(this.findContacts, 300);
    }
  };

  findContacts = () => {
    const { search } = this.state;
    const { company_id } = this.props;
    var url = "/crm_api/contact_search?search=" + search;
    if (!!company_id) {
      url += "&company_id=" + company_id;
    }
    this.fetchContacts(url);
  };

  fetchContacts = (url, callback) => {
    const { csrf_token } = this.props;
    fetch(url, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accepts: "application/json",
        "X-CSRF-Token": csrf_token,
      },
    })
      .then((response) => response.json())
      .then((contacts) => {
        callback ? callback(contacts) : this.setState({ contacts });
      });
  };

  // When the user clicks on a checkbox next to a user,
  // clear the search term and all the other contacts from the list
  contactSelected = (contact) => {
    this.setState({
      search: "",
      contacts: [contact],
    });
  };

  render() {
    const { autoFocus } = this.props;
    const { search, contacts } = this.state;
    return (
      <div>
        <input
          className="form-control"
          placeholder="Enter contact name..."
          type="text"
          id="contact_name"
          value={search}
          autoFocus={autoFocus}
          onKeyPress={this.onKeyPress}
          onChange={this.handlSearchChange}
        />
        {contacts.length == 0 &&
          search &&
          search.length < 4 && (
            <span className="small">Must enter at-least 4 characters to begin search...</span>
          )}
        <Contacts contacts={contacts} contactSelected={this.contactSelected} />
      </div>
    );
  }
}

ContactSearcher.propTypes = {
  autoFocus: PropTypes.bool,
  company_id: PropTypes.number,
  csrf_token: PropTypes.string.isRequired,
};

ContactSearcher.defaultProps = {
  autoFocus: true,
  company_id: null,
};

export default ContactSearcher;
